import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{attrs:{"d-flex":"","cols":"12"}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c(VCard,{staticClass:"VWidget main-card",attrs:{"flat":""}},[_c('flow-log')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }